import type { ICompany } from 'src/ts/interfaces';
import CompanyDetailsFormNew from './CompanyDetailsFormNew';

export type CompanyDetailsFormProps = {
  company?: ICompany;
  handleOnSubmit: (data: any) => void;
  isSaving?: boolean;
  settingsLink?: string | null;
};

const CompanyDetailsFormWrapper = (props: CompanyDetailsFormProps) => {
  return <CompanyDetailsFormNew {...props} />;
};

export default CompanyDetailsFormWrapper;
